import React from 'react';
import { usePreferencesStore } from '../../store/preferencesStore';
import { useAuthStore } from '../../store/authStore';
import DataExportSection from './DataExportSection';
import UsageDataSection from './UsageDataSection';
import CloudRemovalSection from './CloudRemovalSection';
import { LocalEncryptionSection } from './LocalEncryptionSection';

/* ── Privacy tab ─────────────────────────────────────────────────────────────── */
export const PrivacyTab = ({ t }) => {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const language = usePreferencesStore((s) => s.language);
  return (
    <>
      {isAuthenticated && <CloudRemovalSection t={t} language={language} />}
      <UsageDataSection t={t} />
      <LocalEncryptionSection />
      {isAuthenticated && <DataExportSection t={t} />}
    </>
  );
};
